export default "__VITE_ASSET__Dt6fN_fT__"